<template>
  <div class="mission flex-1 relative" :class="[mission.type, {completed: mission.completed}]" :style="{zIndex: 15 - order}" @click="select">
    <div class="progress relative justify-center">
      <div class="before absolute" v-if="order > 0">
        <div class="gauge"></div>
      </div>
      <div class="circle absolute"></div>
    </div>
    <div class="image d-flex relative mx-1">
      <img :src="mission.img" alt="">
      <img class="completed absolute-center" v-show="mission.completed" src="/static/img/completed.png">
    </div>
    <div class="info flex-direction-column justify-center">
      <h3 class="my-0">{{ mission.name }}</h3>
      <p>{{ mission.desc }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mission',
  props: ['mission', 'order'],
  data: () => ({
  }),
  methods: {
    select () {
      this.$emit('select', this.mission)
    }
  }
}
</script>

<style scoped>
.mission {
  display: flex;  
  width: 300px;
}
.mission:hover .image {
  background: #ffffff;
}
.image {
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  margin: auto 0;
  background: #f3f4f7;
  border: solid 1px #b0b0ba;
  cursor: pointer;
}
.main .image {
  height: 140px;
}
.sub .image {
  height: 90px;
}
.mission img {
  width: 100px;
  transition: transform .3s;
}
.main img {
  width: 100px;
}
.sub img {
  width: 60px;
}
.mission:hover .image img:not(.completed) {
  transform: translateY(-5px);
}
.info {
  width: 200px;
  word-break: keep-all;
}
.progress {
  width: 100px;
}
.progress .before {
  width: 5px;
  background-color: gray;
}
.progress .circle {
  display: inline-block;
  top: 40px;
  border-radius: 50%;
}
.main .progress .circle {
  width: 30px;
  height: 30px;
  background: white;
  border: solid 5px gray;
}
.sub .progress .circle {
  width: 20px;
  height: 20px;
  background: gray;
}
.completed .progress .before,
.completed .progress .circle {
  background: #dab3f2;
  border-color: #dab3f2;
}
.main.completed .progress .circle::after {
  content: '✓';
  top: 10px;
  left: 15px;
  color: white;
  font-size: 20px;
}
@media screen and (max-width: 640px) {
.mission {
  height: 150px;
}
.mission {
  flex-direction: row;
}
.info {
  text-align: left;
}
.info p {
  font-size: small;
}
.sub .info {
  margin-left: 40px;
}
.progress .before {
  top: -75px;
  height: 150px;
}
.progress .circle {
  top: 75px;
}
}
@media screen and (min-width: 641px) {
.mission {
  height: 100px;
}
.main {
  flex-direction: row;
  transform: translateX(119px);
}
.main .info {
  text-align: left;
}
.sub {
  flex-direction: row-reverse;
  transform: translateX(-119px);
}
.sub .info {
  text-align: right;
}
.progress .before {
  top: -50px;
  height: 100px;
}
.completed .progress .before,
.completed .progress .circle {
  background: #dab3f2;
}
}
</style>



// WEBPACK FOOTER //
// src/components/Mission/mission.vue